<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <!-- Modal Dialog starts here -->
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    data-dismiss="modal"
                    aria-label="Close"
                    (click)="close()"
                    class="close">
                    <i class="nlrp-icon nlrp-icon-close"></i
                ></button>
                <h4 class="modal-title">{{title}}</h4>
            </div>
            <div class="modal-body">
                <object
                    type="{{type}}"
                    width="{{width}}"
                    height="{{height}}"
                    [data]="url | sanitizeResource: 'url'"></object>
            </div>
            <div class="modal-footer">
                <div class="form-group">
                    <input
                        type="button"
                        class="btn btn-warning nlr-btn-sm"
                        (click)="close()"
                        value="Close"
                /></div>
            </div>
        </div>
    </div>
</div>
